export default "__VITE_ASSET__Cqf4H7UG__"